import React, { useState } from "react";
import {
  TextField,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Tabs,
  Tab,
  Box,
  IconButton,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function PlinkoConfig({
  gameConfig,
  setGameConfig,
  loading = false,
  gameProvider,
}) {
  const [activeTab, setActiveTab] = useState(0);
  const { isViewer } = getUserPermissions();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const initializeData = () => {
    if (!gameConfig.configs || !Array.isArray(gameConfig.configs)) {
      return Array(2)
        .fill(null)
        .map(() =>
          Array(6)
            .fill(null)
            .map(() => ({
              multiplier: 1.0,
              winProbability: 0.0,
            }))
        );
    }
    return gameConfig.configs;
  };

  const horseRacingData = initializeData();

  const handleInputChange = (rowIndex, colIndex, field, value) => {
    const newData = [...horseRacingData];
    newData[rowIndex][colIndex] = {
      ...newData[rowIndex][colIndex],
      [field]: parseFloat(value) || 0,
    };

    setGameConfig({
      ...gameConfig,
      configs: newData,
    });
  };

  /*
    const handleAddRow = () => {
        const newRow = Array(6).fill(null).map(() => ({
            multiplier: 1.0,
            winProbability: 0.0
        }));

        const newData = [...horseRacingData, newRow];
        setGameConfig({
            ...gameConfig,
            configs: newData
        });
    };
    */

  const handleDeleteRow = (rowIndex) => {
    if (horseRacingData.length <= 1) return;

    const newData = horseRacingData.filter((_, index) => index !== rowIndex);
    setGameConfig({
      ...gameConfig,
      configs: newData,
    });
  };

  const handleEntryChange = (entryIndex, value) => {
    const newEntries = [...(gameConfig.entries || Array(8).fill(""))];
    newEntries[entryIndex] = value;
    setGameConfig({
      ...gameConfig,
      entries: newEntries,
    });
  };

  console.log("Horse Racing Data:", gameConfig);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Horse Racing Configuration
        </Typography>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="horse racing tabs"
        >
          <Tab label="Races" />
          <Tab label="Entries" />
        </Tabs>

        {activeTab === 0 && (
          <Box sx={{ mt: 2 }}>
            <TableContainer
              component={Paper}
              sx={{ boxShadow: 3, borderRadius: 2 }}
            >
              <Table size="small" sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        borderRight: "1px solid #e0e0e0",
                        backgroundColor: "#e3f2fd",
                        minWidth: 100,
                      }}
                    >
                      Slot
                    </TableCell>
                    {gameConfig.configs &&
                      Array(gameConfig.configs[0].length)
                        .fill(null)
                        .map((_, index) => (
                          <TableCell
                            key={`header-${index}`}
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.875rem",
                              borderRight: "1px solid #e0e0e0",
                              backgroundColor: "#e8f5e8",
                              minWidth: 140,
                            }}
                          >
                            Slot {index + 1}
                          </TableCell>
                        ))}
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        backgroundColor: "#fff3e0",
                        minWidth: 100,
                      }}
                    >
                      Total Probability
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {horseRacingData.map((row, rowIndex) => (
                    <TableRow
                      key={`race-${rowIndex}`}
                      sx={{
                        "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                        "&:hover": { backgroundColor: "#f0f0f0" },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          borderRight: "1px solid #e0e0e0",
                          backgroundColor: "#e3f2fd",
                          fontWeight: "bold",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="primary"
                          >
                            Config {rowIndex + 1}
                          </Typography>
                          {!isViewer && (
                            <IconButton
                              onClick={() => handleDeleteRow(rowIndex)}
                              disabled={loading || horseRacingData.length <= 1}
                              size="small"
                              sx={{
                                color:
                                  horseRacingData.length <= 1
                                    ? "#ccc"
                                    : "#d32f2f",
                                "&:hover": {
                                  backgroundColor:
                                    horseRacingData.length <= 1
                                      ? "transparent"
                                      : "#ffcdd2",
                                },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                      {row.map((horse, colIndex) => (
                        <TableCell
                          key={`horse-${rowIndex}-${colIndex}`}
                          sx={{
                            borderRight: "1px solid #e0e0e0",
                            padding: "12px",
                            verticalAlign: "top",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1.5,
                              minHeight: 120,
                            }}
                          >
                            <TextField
                              size="small"
                              fullWidth
                              label="Multiplier"
                              value={horse.multiplier}
                              onChange={(e) =>
                                handleInputChange(
                                  rowIndex,
                                  colIndex,
                                  "multiplier",
                                  e.target.value
                                )
                              }
                              variant="outlined"
                              disabled={loading}
                              type="number"
                              step="0.01"
                              inputProps={{ min: 0 }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                  "&:hover": {
                                    backgroundColor: "#f8f9fa",
                                  },
                                  "&.Mui-focused": {
                                    backgroundColor: "#ffffff",
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  color: "#1976d2",
                                  fontWeight: 500,
                                },
                              }}
                            />
                            <TextField
                              size="small"
                              fullWidth
                              label="Win Probability"
                              value={horse.winProbability}
                              onChange={(e) =>
                                handleInputChange(
                                  rowIndex,
                                  colIndex,
                                  "winProbability",
                                  e.target.value
                                )
                              }
                              variant="outlined"
                              disabled={loading}
                              type="number"
                              step="0.0001"
                              inputProps={{ min: 0, max: 1 }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                  "&:hover": {
                                    backgroundColor: "#f8f9fa",
                                  },
                                  "&.Mui-focused": {
                                    backgroundColor: "#ffffff",
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  color: "#388e3c",
                                  fontWeight: 500,
                                },
                              }}
                            />
                            <Typography
                              variant="body3"
                              color="textSecondary"
                              sx={{ textAlign: "center" }}
                            >
                              RTP:{" "}
                              {Math.round(
                                horse.multiplier *
                                  (parseFloat(horse.winProbability) * 100 || 0)
                              )}
                              %
                            </Typography>
                          </Box>
                        </TableCell>
                      ))}
                      <TableCell
                        sx={{
                          padding: "12px",
                          verticalAlign: "middle",
                          textAlign: "center",
                          backgroundColor: "#fff3e0",
                        }}
                      >
                        {(() => {
                          const totalProbability = row.reduce(
                            (sum, horse) =>
                              sum + (parseFloat(horse.winProbability) || 0),
                            0
                          );
                          const totalRtp = row.reduce(
                            (sum, horse) =>
                              sum +
                              parseFloat(horse.multiplier) *
                                (parseFloat(horse.winProbability) || 0),
                            0
                          );
                          const isExactlyOne =
                            Math.abs(totalProbability - 1) < 0.0001;
                          const avgRtp = totalRtp / row.length || 0;
                          return (
                            <>
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                sx={{
                                  color: isExactlyOne ? "#2e7d32" : "#d32f2f",
                                  fontSize: "0.875rem",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  backgroundColor: isExactlyOne
                                    ? "#e8f5e8"
                                    : "#ffebee",
                                  display: "inline-block",
                                }}
                              >
                                {totalProbability.toFixed(4)}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                Avg RTP: {Math.round(avgRtp * 1000) / 10}%
                              </Typography>
                            </>
                          );
                        })()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {/**
                         * <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={handleAddRow}
                                disabled={loading}
                                sx={{
                                    backgroundColor: '#2e7d32',
                                    '&:hover': {
                                        backgroundColor: '#1b5e20'
                                    }
                                }}
                            >
                                Add New Race
                            </Button>
                        </Box>
                         */}
          </Box>
        )}

        {activeTab === 1 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Entry Configuration
            </Typography>
            <Grid container spacing={3}>
              {Array(8)
                .fill(null)
                .map((_, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={`entry-${index}`}
                  >
                    <TextField
                      fullWidth
                      label={`Entry ${index + 1}`}
                      value={gameConfig.entries?.[index] || ""}
                      onChange={(e) => handleEntryChange(index, e.target.value)}
                      variant="outlined"
                      disabled={loading}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#ffffff",
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#ffffff",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "#1976d2",
                          fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>
        )}
      </Grid>
    </Grid>
  );
}
